require('../common/jv.common.parse-querystring.service');
require('./jv.register.form.validation.factory.js');

angular.module('jv.register.form.controller', [
    'jv.common.parse-querystring.service',
    'jv.register.form.validation.factory'
    ])
    .controller('jvUserRegistrationController', ['$scope', 'jvRegistrationSVC','$log','parseQuerystring','$window','jvUserRegistrationValidationFAC','jvPasswordPolicyFAC',
        function ($scope, jvRegistrationSVC, $log, parseQuerystring, $window, jvUserRegistrationValidationFAC, jvPasswordPolicyFAC) {
            $scope.flags = $scope.flags || {};
            $scope.flags.loading = true;
            $scope.queryStringAsObject = parseQuerystring($window.location.search);
            $scope.register = {
                timezones:[]
            };
            $scope.passwordPolicy = jvPasswordPolicyFAC;
            //Asking Geolocation for User
            if(navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position){
                    $scope.$apply(function(){
                        if(position && position.coords){
                            $scope.register.latitude = position.coords.latitude;
                            $scope.register.longitude = position.coords.longitude;
                        }
                    });
                });
            }
            $scope.validate = jvUserRegistrationValidationFAC(false);

            $scope.getData = {
                request: function(urlEId){
                    $scope.flags.loading = true;
                    jvRegistrationSVC.getRegistration(urlEId, this.success, this.error);
                },
                error: function(err){
                    $log.error(err);
                    $scope.flags.loading = false;
                },
                success: function(response){
                    if(response){
                        if(response.passwordDisabled){
                            response.confirmPasswordDisabled = true;
                        }
                        angular.extend($scope.register, response);
                    }else{
                        $log.info('Registration GET: Response is empty.');
                        $window.location.href = '/admin/info/inconsistency.html';
                    }
                    $scope.flags.loading = false;
                }
            };

            $scope.postData = {
                prepare: function(){
                    //Mobile use-case where confirm password is not shown but for validation and POST, copy password to confirmPassword
                    if($scope.register.confirmPasswordDisabled){
                        $scope.register.confirmPassword = $scope.register.password;
                    }
                    return this;
                },
                validate: function(registerObj){
                    //Validate that firstName, lastName, email, timezoneId
                    var ignore = !registerObj.nameChangeAllowed;
                    return ($scope.validate.input(registerObj.firstName, '', 'value', ignore) &&
                        $scope.validate.input(registerObj.lastName, '','value', ignore) &&
                        $scope.validate.input(registerObj.email, '','value', ignore) &&
                        $scope.validate.input(registerObj.timeZoneId, '','value', false) &&
                        $scope.validate.input(registerObj.password, '', 'strength', registerObj.passwordDisabled) &&
                        $scope.validate.input(registerObj.password, registerObj.confirmPassword,'mismatch', registerObj.passwordDisabled)
                    );
                },
                request: function(urlEId){
                    $scope.validate = jvUserRegistrationValidationFAC(true);
                    if($scope.postData.prepare().validate($scope.register)){
                        $scope.flags.loading = true;
                        jvRegistrationSVC.postRegistration(urlEId, $scope.register, this.success, this.error);
                    }
                },
                success: function(response){
                    if(response){
                        $window.location.href  = response;
                    }else{
                        $log.error('Error in registration request with urlEId');
                        $window.location.href = '/admin/info/inconsistency.html';
                    }
                    $scope.flags.loading = false;
                },
                error: $scope.getData.error
            };

           //Check if URL is consistent and has UrlEId as param else redirect to incosistency page
            if($scope.queryStringAsObject && $scope.queryStringAsObject.urlEId){
                $scope.getData.request($scope.queryStringAsObject['urlEId']);
            } else{
                $window.location.href = '/admin/info/inconsistency.html';
            }
        }
]);